// Single point of access for build-time env vars.
//
// The original reason for the wrapper was jest: ts-jest emitted CommonJS and
// choked on `import.meta`. That is gone — the suite is vitest, which runs the
// same ESM the browser gets, and there is no src/__mocks__/env.ts any more.
//
// It stays because one place to read env from is worth having on its own: the
// names are typed once, `apiUrl` has a single definition to point at from
// rootURL.ts and vite.config.mts, and adding a variable is one edit.
export const env = {
	// Where the API lives. Required for a production build — see rootURL.ts.
	apiUrl: import.meta.env.VITE_API_URL as string | undefined,
	sunriseAgencyVersion: import.meta.env.VITE_SUNRISE_AGENCY_VERSION as
		| string
		| undefined,
	isDev: import.meta.env.DEV as boolean,
};
